export default {
  data() {
    return {
      site: '',
    }
  },
  mounted() {
    this._updateSiteKey()
  },
  update() {
    this._updateSiteKey()
  },
  methods: {
    _updateSiteKey() {
      this.site = this.$attrs.site_key
    },
    siteSelected(e) {
      this.site = e.key
    },
  },
  watch: {
    '$route.params.site_key': function () {
      this.site = this.$route.params.site_key
    },
    '$attrs.site_key': function () {
      this.site = this.$attrs.site_key
    },
    '$attrs.title': function () {
      // this.site = this.$route.params.site_key
    },
    site(e) {
      this.$emit('site-selected', e)
    },
  },
}
